import { render, staticRenderFns } from "./whybuy.vue?vue&type=template&id=dcafb102&"
import script from "./whybuy.vue?vue&type=script&lang=js&"
export * from "./whybuy.vue?vue&type=script&lang=js&"
import style0 from "./whybuy.vue?vue&type=style&index=0&id=dcafb102&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports